/**
 * Created by hmeerlo on 26/06/15.
 */
import React from 'react'; // eslint-disable-line no-unused-vars
import { Route } from 'react-router';
import App from '../components/App';
import Base from '../components/Base';
import LoginPage from '../components/LoginPage';
import PasswordPage from '../components/PasswordPage';
import HomePage from '../components/HomePage';
import ForgotPasswordPage from '../components/PasswordPage/ForgotPasswordPage';
import ChangePasswordPage from '../components/PasswordPage/ChangePasswordPage';
import BackendSelector from '../components/BackendSelector/BackendSelector';
import ProfilePage from '../components/ProfilePage';

export default function(thestore) {
  function requireAuth(nextState, replace) {
    console.log(nextState.location.pathname);
    if (!thestore || !thestore.getState() || !thestore.getState().login || !thestore.getState().login.user) {
      replace({ pathname: '/login', query: { nextPathname: nextState.location.pathname } });
    } else if (!thestore.getState().login.config) {
      if (thestore.getState().login.user.backends.length > 1) {
        if (nextState.location.pathname != '/pickWebsite') {
          replace({ pathname: '/pickWebsite', query: { nextPathname: nextState.location.pathname } });
        }
      } else {
        if (nextState.location.pathName != '/' && nextState.location.pathName != undefined) {
          replace({ pathname: '/', query: { nextPathname: nextState.location.pathname } });
        }
      }
    }
  }

  function requireBackend(nextState, replace) {
    if (!thestore.getState().login.config && thestore.getState().login.user.backends.length > 1) {
      replace({ pathname: '/pickWebsite', query: { nextPathname: nextState.location.pathname } });
    }
  }

  return (
    <Route name="base" component={Base}>
      <Route name="app" component={App} onEnter={requireAuth}>
        <Route name="home" path="/" component={HomePage} onEnter={requireBackend} />
        <Route name="changeProfile" path="/changeProfile" component={ProfilePage} />
        <Route name="backendSelector" path="/pickWebsite" component={BackendSelector} />
      </Route>
      <Route name="changePassword" path="/changePassword" component={ChangePasswordPage} />
      <Route name="forgotPassword" path="/forgotPassword" component={ForgotPasswordPage} />
      <Route name="updatePassword" path="/updatePassword" component={PasswordPage} />
      <Route name="login" path="/login" component={LoginPage} />
    </Route>
  );
}



// WEBPACK FOOTER //
// /src/routes/routes.js